import './LoadingInstanceData.css';

const LoadingInstanceData = ({clientInstance}) => {
    return (
        <div className="client-instance-loading">
            <div className="loading-card">
                <div className="loading-spinner"></div>
                <h1>Loading Client Data</h1>
                <p>Please wait while we fetch your instance: <strong>{clientInstance}</strong></p>
            </div>
        </div>
    );
};

export default LoadingInstanceData;